import Ajv, { JSONSchemaType } from 'ajv';
import addFormats from 'ajv-formats';

const ajv = new Ajv({
  allErrors: true,
  useDefaults: true,
  keywords: ['uniforms'],
});

addFormats(ajv);

export function createValidator<T>(schema: JSONSchemaType<T>, fieldLabels: Record<string, string>) {
  const validator = ajv.compile(schema);

  return (model: Record<string, unknown>) => {
    validator(model);
    let errors = validator.errors;
    if (validator.errors?.length) {
      const customErrors = errors?.map((error) => {
        const errorMessage = ajv.errorsText([error]) || '';
        switch (error.keyword) {
          case 'format': {
            const match = new RegExp(`data\\/(.*) must match format "(.*)"`).exec(errorMessage);
            const extracted = match ? match[1] : '';
            const extracted2 = match ? match[2] : '';
            return {
              ...error,
              message: `Le champ '${fieldLabels[extracted]}' doit etre au format "${extracted2}".`,
            };
          }
          case 'required': {
            const match = new RegExp(`data must have required property '(.*)'`).exec(errorMessage);
            const matchForFileUpload = new RegExp(
              `data\\/(.*) must have required property 'size'`,
            ).exec(errorMessage);

            const extracted = match ? match[1] : matchForFileUpload ? matchForFileUpload[1] : '';

            return {
              ...error,
              message: `Le champ '${fieldLabels[extracted]}' est obligatoire.`,
            };
          }
          case 'minLength': {
            const limit = error.params.limit;
            const match = new RegExp(
              `data\\/(.*) must NOT have fewer than ${limit} characters`,
            ).exec(errorMessage);
            const extracted = match ? match[1] : '';
            return {
              ...error,
              message: `Le champ '${fieldLabels[extracted]}' doit contenir au moins ${error.params.limit} caracteres.`,
            };
          }
          case 'maxLength': {
            const limit = error.params.limit;
            const match = new RegExp(
              `data\\/(.*) must NOT have more than ${limit} characters`,
            ).exec(errorMessage);
            const extracted = match ? match[1] : '';
            return {
              ...error,
              message: `Le champ '${fieldLabels[extracted]}' doit contenir au plus ${error.params.limit} caracteres.`,
            };
          }

          default:
            return {
              ...error,
              message: ajv.errorsText([error]),
            };
        }
      });
      errors = customErrors;
    }
    return errors?.length ? { details: errors } : null;
  };
}
